import type { ReasonType } from '@atlassiansox/cross-flow-support';

export const reasonTypeDesktop = 'Unsupported platform: Desktop' as const;
export const reasonTypeFallThrough = 'Error: fallthrough' as const;
export const reasonNoExperiment = 'No matching experiment found' as const;
export const reasonControlGroup = 'Control group' as const;

export type DisabledReasons =
  | ReasonType
  | typeof reasonTypeDesktop
  | typeof reasonNoExperiment
  | typeof reasonTypeFallThrough
  | typeof reasonControlGroup;
